import React, { useEffect, useMemo, useState } from 'react';
import { Col, Progress, Row, Button, TabContent, TabPane, Nav, NavItem, NavLink, Input, Form, Spinner } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { teamResumeActions } from '../../../../core/team-resume/actions';
import { ModalViewList } from './ModalViewList';
import MemberDetail from '../member-detail';
import icon_team_arrow_right from '../../../../assets/img/icon-team-arrow-right.svg';
import icon_team_leader from '../../../../assets/img/icon-team-leader.svg';
import classNames from 'classnames';
import icon_tt from '../../../../assets/img/Talentsandteams.svg';
import icon_mp from '../../../../assets/img/MindPattern.svg';
import LoadingIndicator from '../../loading-indicator';
import { api } from '../../../../core/api';


export const renderList = (list, toggle, members, searchTerm = "") => {
    const filteredList = searchTerm
        ? list.filter(memberData =>
            (memberData.member.first_name && memberData.member.first_name.toLowerCase().includes(searchTerm)) ||
            (memberData.member.last_name && memberData.member.last_name.toLowerCase().includes(searchTerm)) ||
            (memberData.member.first_name && memberData.member.last_name && (memberData.member.first_name.toLowerCase() + " " + memberData.member.last_name.toLowerCase()).includes(searchTerm)) ||
            (memberData.member.username && memberData.member.username.toLowerCase().includes(searchTerm))
        )
        : list;

    return filteredList.map(memberData => {
        const member = memberData.member;

        return (
            <div className="member-item mb-2 d-flex align-items-center border rounded-lg p-2 cursor-pointer" key={member.id} onClick={() => toggle({ section: 'detail-member', member_id: member.id })}>
                <div className="d-flex align-items-center text-reset text-decoration-none flex-fill">
                    <div className="pr-2">
                        <img width="32" height="32" src={member.avatar} alt={member.first_name} />
                    </div>
                    <div className="pr-2 w-100">
                        <p className="h6 mb-1 text-truncate text-nowrap">
                            {(member.first_name) ? `${member.first_name} ${member.last_name}` : member.username}
                            {(memberData.leader === 1) ? <img className="talents-icon-arrow ml-2" src={icon_team_leader} width="16" height="auto" alt="Team Leader" /> : null}
                        </p>
                    </div>
                </div>

                <div className="pl-3">
                    <img className="talents-icon-arrow my-auto mr-1" src={icon_team_arrow_right} width="16" height="auto" alt="Arrow" />
                </div>
            </div>
        )
    }
    )
}

export const TeamResume = ({ team, members, quadrants }) => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [showModal, setshowModal] = useState(false);
    const [typeModal, setTypeModal] = useState("");
    const team_resume = useSelector(state => state.team_resume);
    const team_resume_stats = useSelector(state => state.team_resume_stats);
    const [current_section, setSection] = useState(false);
    const [current_member_id, setCurrentMemberId] = useState(false);
    const [loadingMember, setLoadingMember] = useState(false);
    const [currentMember, setCurrentMember] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('completed');
    const [searchTermTTCompleted, setSearchTermTTCompleted] = useState("");
    const [searchTermTTRemaining, setSearchTermTTRemaining] = useState("");
    const [searchTermMPCompleted, setSearchTermMPCompleted] = useState("");
    const [searchTermMPRemaining, setSearchTermMPRemaining] = useState("");

    const handleSearchTTCompleted = (e) => setSearchTermTTCompleted(e.target.value.toLowerCase());
    const handleSearchTTRemaining = (e) => setSearchTermTTRemaining(e.target.value.toLowerCase());
    const handleSearchMPCompleted = (e) => setSearchTermMPCompleted(e.target.value.toLowerCase());
    const handleSearchMPRemaining = (e) => setSearchTermMPRemaining(e.target.value.toLowerCase());

    const toggle = ({ section = 'members-list', member_id = null }) => {
        setIsOpen(!isOpen);
        setSection(section);
        setCurrentMemberId(member_id)
    }

    const count_members_assessed_mp = team_resume_stats.count_mp;
    const count_members_assessed_tt = team_resume_stats.count_tt;
    const total_count_members = team_resume_stats.count_members;
    const count_members_not_assessed_mp = total_count_members - count_members_assessed_mp;
    const count_members_not_assessed_tt = total_count_members - count_members_assessed_tt

    const handleModal = (name) => {
        setshowModal(!showModal);
        setTypeModal(name);
        setSection('members-list');
        setActiveTab('completed');

        setSearchTermTTCompleted("");
        setSearchTermTTRemaining("");
        setSearchTermMPCompleted("");
        setSearchTermMPRemaining("");
    }


    const toggleTab = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    let contentModal = null;
    let title = "";
    let icon = '';

    if (typeModal === 'thinking-talent') {
        title = 'Thinking Talent'
        icon = icon_tt
        contentModal =
            <div>
                <Nav className="text-center mx-n4" tabs>
                    <NavItem className="flex-fill">
                        <NavLink className={classNames({ active: activeTab === 'completed', 'h5': true })} onClick={() => { toggleTab('completed'); }}><span className='font-weight-semibold'>Completed</span></NavLink>
                    </NavItem>
                    <NavItem className="flex-fill">
                        <NavLink className={classNames({ active: activeTab === 'remaining', 'h5': true })} onClick={() => { toggleTab('remaining'); }}><span className='font-weight-semibold'>Not Completed</span></NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab} className='mx-n4 py-3'>
                    <TabPane tabId="completed" className='px-4'>
                        {count_members_assessed_tt > 0 &&
                            <>
                                <div>
                                    <Form onSubmit={e => { e.preventDefault() }} className='mb-2'>
                                        <div className="search-member-input rounded border d-flex align-items-center">
                                            <span className='text-muted ml-2 my-1 d-block' >
                                                <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} viewBox="0 0 20 21" fill='currentColor'>
                                                    <g>
                                                        <path d="M18.1,17.4L18.1,17.4L18.1,17.4c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3
                                            c0,0.1-0.1,0.2-0.2,0.3s-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2l-3.7-3.7l0,0l0,0
                                            c-1.4,1.1-3.2,1.6-5,1.4c-1.8-0.2-3.5-1-4.7-2.4C2.2,12.6,1.6,10.8,1.6,9c0.1-1.8,0.8-3.5,2.1-4.8c1.3-1.3,3-2,4.8-2.1
                                            c1.8-0.1,3.6,0.6,4.9,1.8c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.4,5l0,0l0,0L18.1,17.4z M3.4,9.3L3.4,9.3
                                            C3.4,10.7,3.9,12,5,13c1,1,2.4,1.6,3.8,1.6h0c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4c0.4-1,0.5-2.1,0.3-3.1
                                            c-0.2-1-0.7-2-1.5-2.8S10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2C3.7,7.1,3.4,8.2,3.4,9.3z"/>
                                                        <path d="M17.5,18.9c-0.1,0-0.2,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2L13.1,15c-1.5,1.1-3.3,1.6-5.1,1.5
                                            c-1.8-0.2-3.5-1-4.7-2.4c-1.2-1.4-1.8-3.1-1.8-5c0.1-1.8,0.8-3.6,2.1-4.9c1.3-1.3,3-2,4.9-2.1c1.8-0.1,3.6,0.6,5,1.8
                                            c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.5,5.1l3.8,3.8l0,0c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4s0,0.2-0.1,0.4
                                            s-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C17.7,18.9,17.6,18.9,17.5,18.9z M13.1,14.8L13.1,14.8l3.8,3.8c0.1,0.1,0.2,0.1,0.3,0.2
                                            c0.2,0.1,0.4,0.1,0.6,0c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3
                                            c0-0.1-0.1-0.2-0.2-0.3l-0.1,0l0,0l-3.7-3.7l0.1-0.1c1.1-1.4,1.6-3.2,1.4-5c-0.2-1.8-1-3.4-2.4-4.6s-3.1-1.8-4.9-1.8
                                            C6.7,2.2,5,3,3.7,4.2c-1.3,1.3-2,3-2.1,4.8c-0.1,1.8,0.6,3.5,1.8,4.9c1.2,1.4,2.8,2.2,4.6,2.4C9.8,16.5,11.6,16,13.1,14.8
                                            L13.1,14.8z M8.8,14.7c-1.5,0-2.8-0.6-3.8-1.6c-1-1-1.6-2.4-1.6-3.8l0,0c0-1.1,0.3-2.1,0.9-3c0.6-0.9,1.4-1.6,2.4-2
                                            c1-0.4,2.1-0.5,3.1-0.3c1.1,0.2,2,0.7,2.8,1.5c0.8,0.8,1.3,1.7,1.5,2.8c0.2,1.1,0.1,2.1-0.3,3.1c-0.4,1-1.1,1.8-2,2.4
                                            C10.9,14.4,9.8,14.7,8.8,14.7z M3.4,9.3C3.4,10.7,4,12,5,13c1,1,2.3,1.6,3.8,1.6c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4
                                            c0.4-1,0.5-2,0.3-3.1c-0.2-1-0.7-2-1.5-2.7C11.8,4.7,10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2
                                            C3.7,7.2,3.4,8.2,3.4,9.3L3.4,9.3z"/>
                                                    </g>
                                                </svg>
                                            </span>
                                            <Input
                                                type="text"
                                                className="border-0"
                                                placeholder="Search Members"
                                                value={searchTermTTCompleted}
                                                onChange={handleSearchTTCompleted}
                                            />
                                        </div>
                                    </Form>
                                </div>
                                <div className="member-list">
                                    {renderList(team_resume.data?.members_tt || [], toggle, members, searchTermTTCompleted)}
                                </div>
                            </>
                        }
                        {count_members_assessed_tt === 0 &&
                            <p>No members</p>
                        }
                    </TabPane>
                    <TabPane tabId="remaining" className='px-4'>
                        {count_members_not_assessed_tt > 0 &&
                            <>
                                <div>
                                    <Form onSubmit={e => { e.preventDefault() }} className='mb-2'>
                                        <div className="search-member-input rounded border d-flex align-items-center">
                                            <span className='text-muted ml-2 my-1 d-block' >
                                                <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} viewBox="0 0 20 21" fill='currentColor'>
                                                    <g>
                                                        <path d="M18.1,17.4L18.1,17.4L18.1,17.4c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3
                                            c0,0.1-0.1,0.2-0.2,0.3s-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2l-3.7-3.7l0,0l0,0
                                            c-1.4,1.1-3.2,1.6-5,1.4c-1.8-0.2-3.5-1-4.7-2.4C2.2,12.6,1.6,10.8,1.6,9c0.1-1.8,0.8-3.5,2.1-4.8c1.3-1.3,3-2,4.8-2.1
                                            c1.8-0.1,3.6,0.6,4.9,1.8c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.4,5l0,0l0,0L18.1,17.4z M3.4,9.3L3.4,9.3
                                            C3.4,10.7,3.9,12,5,13c1,1,2.4,1.6,3.8,1.6h0c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4c0.4-1,0.5-2.1,0.3-3.1
                                            c-0.2-1-0.7-2-1.5-2.8S10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2C3.7,7.1,3.4,8.2,3.4,9.3z"/>
                                                        <path d="M17.5,18.9c-0.1,0-0.2,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2L13.1,15c-1.5,1.1-3.3,1.6-5.1,1.5
                                            c-1.8-0.2-3.5-1-4.7-2.4c-1.2-1.4-1.8-3.1-1.8-5c0.1-1.8,0.8-3.6,2.1-4.9c1.3-1.3,3-2,4.9-2.1c1.8-0.1,3.6,0.6,5,1.8
                                            c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.5,5.1l3.8,3.8l0,0c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4s0,0.2-0.1,0.4
                                            s-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C17.7,18.9,17.6,18.9,17.5,18.9z M13.1,14.8L13.1,14.8l3.8,3.8c0.1,0.1,0.2,0.1,0.3,0.2
                                            c0.2,0.1,0.4,0.1,0.6,0c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3
                                            c0-0.1-0.1-0.2-0.2-0.3l-0.1,0l0,0l-3.7-3.7l0.1-0.1c1.1-1.4,1.6-3.2,1.4-5c-0.2-1.8-1-3.4-2.4-4.6s-3.1-1.8-4.9-1.8
                                            C6.7,2.2,5,3,3.7,4.2c-1.3,1.3-2,3-2.1,4.8c-0.1,1.8,0.6,3.5,1.8,4.9c1.2,1.4,2.8,2.2,4.6,2.4C9.8,16.5,11.6,16,13.1,14.8
                                            L13.1,14.8z M8.8,14.7c-1.5,0-2.8-0.6-3.8-1.6c-1-1-1.6-2.4-1.6-3.8l0,0c0-1.1,0.3-2.1,0.9-3c0.6-0.9,1.4-1.6,2.4-2
                                            c1-0.4,2.1-0.5,3.1-0.3c1.1,0.2,2,0.7,2.8,1.5c0.8,0.8,1.3,1.7,1.5,2.8c0.2,1.1,0.1,2.1-0.3,3.1c-0.4,1-1.1,1.8-2,2.4
                                            C10.9,14.4,9.8,14.7,8.8,14.7z M3.4,9.3C3.4,10.7,4,12,5,13c1,1,2.3,1.6,3.8,1.6c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4
                                            c0.4-1,0.5-2,0.3-3.1c-0.2-1-0.7-2-1.5-2.7C11.8,4.7,10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2
                                            C3.7,7.2,3.4,8.2,3.4,9.3L3.4,9.3z"/>
                                                    </g>
                                                </svg>
                                            </span>
                                            <Input
                                                type="text"
                                                className="border-0"
                                                placeholder="Search Members"
                                                value={searchTermTTRemaining}
                                                onChange={handleSearchTTRemaining}
                                            />
                                        </div>
                                    </Form>
                                </div>

                                <div className="member-list">
                                    {renderList(team_resume.data?.members_no_tt || [], toggle, members, searchTermTTRemaining)}
                                </div>
                            </>
                        }
                        {count_members_not_assessed_tt === 0 &&
                            <p>No members remains</p>
                        }
                    </TabPane>
                </TabContent>
            </div>
    } else if (typeModal === "mind-patern") {
        title = 'Mind Patern'
        icon = icon_mp
        contentModal = <div>
            <Nav className="text-center mx-n4" tabs>
                <NavItem className="flex-fill">
                    <NavLink className={classNames({ active: activeTab === 'completed', 'h5': true })} onClick={() => { toggleTab('completed'); }}><span className='font-weight-semibold'>Completed</span></NavLink>
                </NavItem>
                <NavItem className="flex-fill">
                    <NavLink className={classNames({ active: activeTab === 'remaining', 'h5': true })} onClick={() => { toggleTab('remaining'); }}><span className='font-weight-semibold'>Not Completed</span></NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab} className='mx-n4 py-3'>
                <TabPane tabId="completed" className='px-4'>
                    {count_members_assessed_mp > 0 &&
                        <>
                            <div>
                                <Form onSubmit={e => { e.preventDefault() }} className='mb-2'>
                                    <div className="search-member-input rounded border d-flex align-items-center">
                                        <span className='text-muted ml-2 my-1 d-block' >
                                            <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} viewBox="0 0 20 21" fill='currentColor'>
                                                <g>
                                                    <path d="M18.1,17.4L18.1,17.4L18.1,17.4c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3
                                            c0,0.1-0.1,0.2-0.2,0.3s-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2l-3.7-3.7l0,0l0,0
                                            c-1.4,1.1-3.2,1.6-5,1.4c-1.8-0.2-3.5-1-4.7-2.4C2.2,12.6,1.6,10.8,1.6,9c0.1-1.8,0.8-3.5,2.1-4.8c1.3-1.3,3-2,4.8-2.1
                                            c1.8-0.1,3.6,0.6,4.9,1.8c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.4,5l0,0l0,0L18.1,17.4z M3.4,9.3L3.4,9.3
                                            C3.4,10.7,3.9,12,5,13c1,1,2.4,1.6,3.8,1.6h0c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4c0.4-1,0.5-2.1,0.3-3.1
                                            c-0.2-1-0.7-2-1.5-2.8S10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2C3.7,7.1,3.4,8.2,3.4,9.3z"/>
                                                    <path d="M17.5,18.9c-0.1,0-0.2,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2L13.1,15c-1.5,1.1-3.3,1.6-5.1,1.5
                                            c-1.8-0.2-3.5-1-4.7-2.4c-1.2-1.4-1.8-3.1-1.8-5c0.1-1.8,0.8-3.6,2.1-4.9c1.3-1.3,3-2,4.9-2.1c1.8-0.1,3.6,0.6,5,1.8
                                            c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.5,5.1l3.8,3.8l0,0c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4s0,0.2-0.1,0.4
                                            s-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C17.7,18.9,17.6,18.9,17.5,18.9z M13.1,14.8L13.1,14.8l3.8,3.8c0.1,0.1,0.2,0.1,0.3,0.2
                                            c0.2,0.1,0.4,0.1,0.6,0c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3
                                            c0-0.1-0.1-0.2-0.2-0.3l-0.1,0l0,0l-3.7-3.7l0.1-0.1c1.1-1.4,1.6-3.2,1.4-5c-0.2-1.8-1-3.4-2.4-4.6s-3.1-1.8-4.9-1.8
                                            C6.7,2.2,5,3,3.7,4.2c-1.3,1.3-2,3-2.1,4.8c-0.1,1.8,0.6,3.5,1.8,4.9c1.2,1.4,2.8,2.2,4.6,2.4C9.8,16.5,11.6,16,13.1,14.8
                                            L13.1,14.8z M8.8,14.7c-1.5,0-2.8-0.6-3.8-1.6c-1-1-1.6-2.4-1.6-3.8l0,0c0-1.1,0.3-2.1,0.9-3c0.6-0.9,1.4-1.6,2.4-2
                                            c1-0.4,2.1-0.5,3.1-0.3c1.1,0.2,2,0.7,2.8,1.5c0.8,0.8,1.3,1.7,1.5,2.8c0.2,1.1,0.1,2.1-0.3,3.1c-0.4,1-1.1,1.8-2,2.4
                                            C10.9,14.4,9.8,14.7,8.8,14.7z M3.4,9.3C3.4,10.7,4,12,5,13c1,1,2.3,1.6,3.8,1.6c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4
                                            c0.4-1,0.5-2,0.3-3.1c-0.2-1-0.7-2-1.5-2.7C11.8,4.7,10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2
                                            C3.7,7.2,3.4,8.2,3.4,9.3L3.4,9.3z"/>
                                                </g>
                                            </svg>
                                        </span>
                                        <Input
                                            type="text"
                                            className="border-0"
                                            placeholder="Search Members"
                                            value={searchTermMPCompleted}
                                            onChange={handleSearchMPCompleted}
                                        />
                                    </div>
                                </Form>
                            </div>
                            <div className="member-list">
                                {renderList(team_resume.data?.members_mp || [], toggle, members, searchTermMPCompleted)}
                            </div>
                        </>
                    }
                    {count_members_assessed_mp === 0 &&
                        <p>No members</p>
                    }
                </TabPane>
                <TabPane tabId="remaining" className='px-4'>
                    {count_members_not_assessed_mp > 0 &&
                        <>
                            <div>
                                <Form onSubmit={e => { e.preventDefault() }} className='mb-2'>
                                    <div className="search-member-input rounded border d-flex align-items-center">
                                        <span className='text-muted ml-2 my-1 d-block' >
                                            <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} viewBox="0 0 20 21" fill='currentColor'>
                                                <g>
                                                    <path d="M18.1,17.4L18.1,17.4L18.1,17.4c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3
                                            c0,0.1-0.1,0.2-0.2,0.3s-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2l-3.7-3.7l0,0l0,0
                                            c-1.4,1.1-3.2,1.6-5,1.4c-1.8-0.2-3.5-1-4.7-2.4C2.2,12.6,1.6,10.8,1.6,9c0.1-1.8,0.8-3.5,2.1-4.8c1.3-1.3,3-2,4.8-2.1
                                            c1.8-0.1,3.6,0.6,4.9,1.8c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.4,5l0,0l0,0L18.1,17.4z M3.4,9.3L3.4,9.3
                                            C3.4,10.7,3.9,12,5,13c1,1,2.4,1.6,3.8,1.6h0c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4c0.4-1,0.5-2.1,0.3-3.1
                                            c-0.2-1-0.7-2-1.5-2.8S10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2C3.7,7.1,3.4,8.2,3.4,9.3z"/>
                                                    <path d="M17.5,18.9c-0.1,0-0.2,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2L13.1,15c-1.5,1.1-3.3,1.6-5.1,1.5
                                            c-1.8-0.2-3.5-1-4.7-2.4c-1.2-1.4-1.8-3.1-1.8-5c0.1-1.8,0.8-3.6,2.1-4.9c1.3-1.3,3-2,4.9-2.1c1.8-0.1,3.6,0.6,5,1.8
                                            c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.5,5.1l3.8,3.8l0,0c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4s0,0.2-0.1,0.4
                                            s-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C17.7,18.9,17.6,18.9,17.5,18.9z M13.1,14.8L13.1,14.8l3.8,3.8c0.1,0.1,0.2,0.1,0.3,0.2
                                            c0.2,0.1,0.4,0.1,0.6,0c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3
                                            c0-0.1-0.1-0.2-0.2-0.3l-0.1,0l0,0l-3.7-3.7l0.1-0.1c1.1-1.4,1.6-3.2,1.4-5c-0.2-1.8-1-3.4-2.4-4.6s-3.1-1.8-4.9-1.8
                                            C6.7,2.2,5,3,3.7,4.2c-1.3,1.3-2,3-2.1,4.8c-0.1,1.8,0.6,3.5,1.8,4.9c1.2,1.4,2.8,2.2,4.6,2.4C9.8,16.5,11.6,16,13.1,14.8
                                            L13.1,14.8z M8.8,14.7c-1.5,0-2.8-0.6-3.8-1.6c-1-1-1.6-2.4-1.6-3.8l0,0c0-1.1,0.3-2.1,0.9-3c0.6-0.9,1.4-1.6,2.4-2
                                            c1-0.4,2.1-0.5,3.1-0.3c1.1,0.2,2,0.7,2.8,1.5c0.8,0.8,1.3,1.7,1.5,2.8c0.2,1.1,0.1,2.1-0.3,3.1c-0.4,1-1.1,1.8-2,2.4
                                            C10.9,14.4,9.8,14.7,8.8,14.7z M3.4,9.3C3.4,10.7,4,12,5,13c1,1,2.3,1.6,3.8,1.6c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4
                                            c0.4-1,0.5-2,0.3-3.1c-0.2-1-0.7-2-1.5-2.7C11.8,4.7,10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2
                                            C3.7,7.2,3.4,8.2,3.4,9.3L3.4,9.3z"/>
                                                </g>
                                            </svg>
                                        </span>
                                        <Input
                                            type="text"
                                            className="border-0"
                                            placeholder="Search Members"
                                            value={searchTermMPRemaining}
                                            onChange={handleSearchMPRemaining}
                                        />
                                    </div>
                                </Form>
                            </div>
                            <div className="member-list">
                                {renderList(team_resume.data?.members_no_mp || [], toggle, members, searchTermMPRemaining)}
                            </div>
                        </>
                    }
                    {count_members_not_assessed_mp === 0 &&
                        <p>No members remains</p>
                    }
                </TabPane>
            </TabContent>
        </div>
    }

    return (
        <>
            <Row className="pt-md-2">
                <Col md={{ size: 6 }} className="mb-2 mb-md-4">
                    <div className="border rounded p-3">
                        <div className='d-flex justify-content-between mb-2'>
                            <p className='h5 mb-0'>Thinking Talents</p>
                            <Button color="link" className='p-0 text-danger font-weight-semibold' size='sm' disabled={total_count_members === 0 ? true : false} onClick={() => handleModal('thinking-talent')}>View List</Button>
                        </div>

                        {team_resume_stats.isPending && <div className="d-flex justify-content-center align-content-end">
                            <Spinner color="primary" style={{ height: '3rem', width: '3rem' }} />
                        </div>}

                        {!team_resume_stats.isPending && <>
                            <Progress color='orange' value={team_resume_stats.progress_tt} className="overflow-initial mb-2" />
                            <div className="d-flex justify-content-between">
                                <p className="mb-0 small font-weight-medium text-green">{count_members_assessed_tt}/{total_count_members} Completed</p>
                                <p className="mb-0 small font-weight-medium">{count_members_not_assessed_tt}/{total_count_members} Remaining</p>
                            </div>
                        </>}
                    </div>
                </Col>

                <Col md={{ size: 6 }} className="mb-2 mb-md-4">
                    <div className="border rounded p-3">
                        <div className='d-flex justify-content-between mb-2'>
                            <p className='h5 mb-0'>Mind Patterns</p>
                            <Button color="link" className='p-0 text-danger font-weight-semibold' size='sm' disabled={total_count_members === 0 ? true : false} onClick={() => handleModal('mind-patern')}>View List</Button>
                        </div>

                        {team_resume_stats.isPending && <div className="d-flex justify-content-center align-content-end">
                            <Spinner color="primary" style={{ height: '3rem', width: '3rem' }} />
                        </div>}

                        {!team_resume_stats.isPending && <>
                            <Progress color='analytic' value={team_resume_stats.progress_mp} className="overflow-initial mb-2" />
                            <div className="d-flex justify-content-between">
                                <p className="mb-0 small font-weight-medium text-green">{count_members_assessed_mp}/{total_count_members} Completed</p>
                                <p className="mb-0 small font-weight-medium">{count_members_not_assessed_mp}/{total_count_members} Remaining</p>
                            </div>
                        </>}
                    </div>
                </Col>
            </Row>
            <ModalViewList showModal={showModal} handleModal={handleModal} isLoading={team_resume.isPending} contentModal={
                (current_section === "detail-member" && current_member_id) ?
                    <MemberDetail
                        userId={current_member_id}
                        team={team}
                        quadrants={quadrants}
                        hanndleNextSection={toggle}
                    />
                    :
                    contentModal
            }
                title={title}
                icon={icon}
                handleClick={toggle}
                type={typeModal}
            />
        </>
    )
}

